import { useFormik } from "formik";
import React, { useImperativeHandle } from "react";
import { DeviceEventEmitter } from "react-native";
import { useNavigation } from "@react-navigation/native";

import { inviteGuests } from "../http/events";
import { GuestInviteSchema } from "../screens/Schemas";
import { notify } from "./AppToast";
import Button from "@/components/settings/Button";
import { TextField } from "@/components/settings/Field";
import { t } from "@/localization";

const AddGuestForm = ({ event }, ref) => {
  const navigation = useNavigation();

  const { slug } = event;

  const f = useFormik({
    initialValues: {
      name: "",
      email: "",
    },
    validationSchema: GuestInviteSchema,
    onSubmit: async (values, actions) => {
      actions.setSubmitting(true);

      try {
        // Create an event
        const res = await inviteGuests(event, [values]);
        // find id of added guest and push it back to list
        DeviceEventEmitter.emit("guest-add", {
          guest: {
            ...values,
            id: res?.guests?.find((e) => e.email === values.email)?.id,
          },
        });
        notify.success(
          t("Invitation sent"),
          t("{name} will get reminders before you go live.", {
            name: values.name,
          })
        );
        navigation.navigate("GuestList", { slug });
      } catch (err) {
        actions.setSubmitting(false);
        notify.error(
          t("Couldn't send the invitation"),
          String(err?.message || err)
        );
      }
    },
  });

  useImperativeHandle(ref, () => ({
    isReadyToSave: () => {
      return !!f.dirty && !f.isSubmitting;
    },
  }));

  return (
    <>
      <TextField
        label={t("Guest's name")}
        onChangeText={f.handleChange("name")}
        onBlur={f.handleBlur("name")}
        value={f.values.name}
        placeholder={t("e.g. Maria Lopez")}
        onSubmitEditing={() => f.handleSubmit()}
        autoFocus
        error={f.errors.name && f.touched.name ? f.errors.name : null}
      />

      <TextField
        label={t("Email")}
        onChangeText={f.handleChange("email")}
        onBlur={f.handleBlur("email")}
        value={f.values.email}
        placeholder="maria@example.com"
        autoCorrect={false}
        spellCheck={false}
        onSubmitEditing={() => f.handleSubmit()}
        autoCapitalize="none"
        keyboardType="email-address"
        error={f.errors.email && f.touched.email ? f.errors.email : null}
      />

      <Button
        text={t("Send invitation")}
        icon="send-outline"
        variant="primary"
        loading={f.isSubmitting}
        onPress={f.handleSubmit}
        style={{ marginTop: 8 }}
      />
    </>
  );
};

export default React.forwardRef(AddGuestForm);
